import { Resultados } from './api';

type TDescriptor = Omit<Resultados<'descriptorDeUsuarioDesdeToken'>, 'token'>;
type Funciones = TDescriptor['funciones'][number];

export class DescriptorDeUsuario implements TDescriptor {
    public readonly nombreDeUsuario: TDescriptor['nombreDeUsuario'];
    public readonly nombrePersonal: TDescriptor['nombrePersonal'];
    public readonly funciones: Funciones[];

    public constructor({ nombreDeUsuario, nombrePersonal, funciones }: TDescriptor) {
        this.nombreDeUsuario = nombreDeUsuario;
        this.nombrePersonal = nombrePersonal;
        this.funciones = funciones;
    }

    /**
     * Toma como parámetro una lista no vacía de funciones y retorna `true` si el usuario
     * autenticado tiene al menos una de las funciones en la lista, o `false` en caso que
     * no tenga ninguna de ellas. Si el usuario autenticado es un administrador, se retorna
     * `true` para cualquier rol consultado.
     *
     * @example
     * usuario.tieneAlgunaDeEstasFunciones('asesor', 'supervisor')
     */
    public tieneAlgunaDeEstasFunciones(f1: Funciones, ...fs: Funciones[]): boolean {
        if (this.funciones.includes('administrador')) return true;

        for (const funcion of [f1, ...fs]) {
            if (this.funciones.includes(funcion)) return true;
        }
        return false;
    }

    public nombrePersonalCompleto() {
        const {
            primerNombre,
            nombresSecundarios,
            apellidoPaterno,
            apellidoMaterno,
        } = this.nombrePersonal;

        let nombreCompleto = primerNombre;
        nombreCompleto += nombresSecundarios ? ` ${nombresSecundarios}` : '';
        nombreCompleto += apellidoPaterno ? ` ${apellidoPaterno}` : '';
        nombreCompleto += apellidoMaterno ? ` ${apellidoMaterno}` : '';

        return nombreCompleto;
    }
}



// WEBPACK FOOTER //
// ./src/descriptor.tsx